/* eslint-disable import/prefer-default-export */
import find from 'lodash/find';
import indexOf from 'lodash/indexOf';

export const replaceOrInsertItem = (arr, key, newValue) => {
  const newArr = [...arr];

  const match = find(newArr, key);
  if (match) {
    const index = indexOf(newArr, find(newArr, key));
    newArr.splice(index, 1, newValue);
  } else {
    newArr.push(newValue);
  }

  return newArr;
};
